
import "react-multi-date-picker/styles/layouts/prime.css";

import useInput from "hooks/use-input";
import Select, { StylesConfig } from "react-select";

function EditClub({ setUpdater, updater }) {


  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalEdit`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
            ویرایش  تنطیمات
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="shop-setting w-100">
              <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        نوع : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        دسته بندی : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        لاین : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        شهر : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        کالا : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        عرضه کننده : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                         
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                         سقف : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <input
                          id="tags"
                          className=" filterSelect w-100 "
                          style={{ background: "#ddd" , border:"2px solid #ddd",height:"40px", borderRadius:"3px",  outline:"none"}}
                         
                        />
                      </div>
                    </div>
              </div>

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
               
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  
                }}
               
                
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditClub;
